<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="font-family:Calisto MT; font-size:18pt; letter-spacing:1px; padding-top:75px; padding-bottom:15px;">About the Author</h1>
<p>As he wrote in one of his Italian novels (<em>Il fantasma di Andersen</em>): “The most striking episode of my childhood was when the ghost of a tall, slouching boy with a big nose appeared to me: Hans Christian Andersen.” Born in Fano, Italy, but living in Venice, Lucio Angelini is a translator of novels and essays for major Italian publishers (Einaudi, Mondadori, Frassinelli, Fazi, and others) and a writer. He translated into Italian Charlotte Brontë, Virginia Woolf, Edgar Allan Poe, Gandhi, Einstein, Tobias Wolff, Lewis Carroll and others, including Patricia Cornwell’s <em>Body of Evidence</em> (<em>Oggetti di reato</em>, Mondadori). He also translated into Italian three novels by Hans Christian Andersen: <em>Only a Fiddler, O.T. – A Danish Novel, The Two Baronesses</em>. As a writer, he has written mainly short stories for children and young adults. His collection <em>You, Naughty Mum! (And Other Tales)(Quella bruttacattiva della mamma!,</em> Emme Edizioni<em>)</em> was translated into French with the title <em>Méchante Maman</em> (Flammarion). In 2013, he published in Italy <em>The Chinese Gondolier (Il gondoliere cinese)</em>, an environmentalist noir for adults, in support of the campaign for the expulsion of giant cruise ships from the Venetian lagoon.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?36382a1a